import AccidentReport from './AccidentReport'

export default AccidentReport
